import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";
import Logo from "@/components/Logo";
import { track } from "@/lib/track";

export const SIMULATOR_URL = "https://simulator.qpilabs.com";

export default function Nav() {
  const { pathname } = useLocation();
  const onTutorial = pathname.startsWith("/tutorial");
  return (
    <motion.header
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 z-50 w-full border-b border-white/10 bg-[rgba(12,12,15,0.6)] backdrop-blur-xl"
    >
      <div className="container-x flex h-16 items-center justify-between">
        <a href="/" data-testid="nav-home-link" className="transition-opacity hover:opacity-80">
          <Logo />
        </a>
        <nav className="flex items-center gap-6 md:gap-8">
          <a
            href="/publications"
            data-testid="nav-publications-link"
            className="hidden font-mono text-[11px] font-medium uppercase tracking-[0.25em] text-zinc-400 transition-colors hover:text-white sm:inline-block"
          >
            Publications
          </a>
          <a
            href={onTutorial ? "/" : "/tutorial"}
            data-testid={onTutorial ? "nav-home-link-tutorial" : "nav-tutorial-link"}
            className="hidden font-mono text-[11px] font-medium uppercase tracking-[0.25em] text-zinc-400 transition-colors hover:text-white sm:inline-block"
          >
            {onTutorial ? "Home" : "Tutorial"}
          </a>
          <a
            href={SIMULATOR_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => track("simulator_launch")}
            data-testid="nav-launch-simulator"
            className="btn-laser !px-5 !py-2.5"
          >
            Launch Simulator
          </a>
        </nav>
      </div>
    </motion.header>
  );
}
